module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9652.fffd4d72.jpg";